export const ConvertHourMinInMilli = (value) => {
    const time = value.split(":");
    return parseInt(time[0]) * 3600000 + parseInt(time[1]) * 60000;
}